// extracted by mini-css-extract-plugin
export var chip = "_m9-0";
export var icon = "_m9-1";
export var remove = "_m9-2";
export var removeIcon = "_m9-3";